(function() {
    'use strict';

angular.module('wbUtilities')
    .filter('objectToArray', function() {
        return function(input) {
            var out = [];
            for (var i in input) {
                out.push(input[i]);
            }
            return out;
        };
    }).filter('regex', function () {
        return function (input, field, regex) {
            if (!input) { return input; }
            var pattern = new RegExp(regex);
            var out = [];
            for (var i = 0; i < input.length; i++) {
                if (pattern.test(input[i][field])) {
                    out.push(input[i]);
                }
            }
            return out;
        };
    }).filter('wbCurrency', ['$filter', function ($filter) {
        return function (input, symbol, decimals) {
            var out = $filter('currency')(input, symbol, decimals);
            if (out) {
                out = out.replace(".00", "");
            }
            return out;
        };
    }]).filter('ordinal', function() {
        return function(input) {
            var s=["th","st","nd","rd"],
                v=input%100;
            return input+(s[(v-20)%10]||s[v]||s[0]);
        }
    }).filter('capitalize', function() {
        return function(input) {
            return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
        }
    }).filter('ucwords', function() {
        return function(input = "") {
            return input.replace(/(?:^|\s|-)\S/g, function(a) { return a.toUpperCase(); });
        }
    });
})();
